export function impossible(value: never): never {
  throw new Error(`Impossible value: ${value}`);
}

type AllKeys<T> = T extends T ? keyof T : never;
export type DistributiveOmit<T, K extends AllKeys<T>> = T extends T ? Omit<T, K> : never;
export type DistributivePick<T, K extends AllKeys<T>> = T extends T ? Pick<T, K> : never;
